export { default } from './BatchAddToShelfButton';



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchAddToShelfButton/index.js